import React from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import useStyled from "../../hooks/useStyled";
import { InputAdornment } from "@mui/material";

const { styled } = useStyled();

const MaxLengthLabel = styled("div", { shouldForwardProp: false })(
  ({ theme, hasError }) => ({
    color: theme.palette.grey200.main,
    fontSize: 11,
    position: "absolute",
    right: 0,
    bottom: hasError ? 1 : -20,
  })
);

const SFTextField = ({
  onBlur,
  onFocus,
  startAdornment,
  maxLength = null,
  ...props
}) => {
  const [maxLengthVisible, setMaxLengthVisible] = React.useState(false);

  const MaxLengthValue = (length, maxLength, hasError) => (
    <MaxLengthLabel hasError={hasError}>
      {length}/{maxLength}
    </MaxLengthLabel>
  );

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <TextField
        FormHelperTextProps={{ component: "div" }}
        onFocus={() => {
          setMaxLengthVisible(true);
          props.onFocus && props.onFocus();
        }}
        onBlur={() => {
          setMaxLengthVisible(false);
          props.onBlur && props.onBlur();
        }}
        {...(startAdornment && {
          InputProps: {
            startAdornment: <InputAdornment>{startAdornment}</InputAdornment>,
          },
        })}
        {...props}
        {...(maxLength && {
          inputProps: { maxLength },
        })}
        value={props.value}
      />
      {maxLength &&
        maxLengthVisible &&
        MaxLengthValue(props.value.length, maxLength, props.errors?.length > 1)}
    </div>
  );
};

SFTextField.defaultProps = {
  variant: "outlined",
  fullWidth: true,
  size: "medium",
};

SFTextField.propTypes = {
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  onKeyDown: PropTypes.func,
  hiddenLabel: PropTypes.bool,
  fullWidth: PropTypes.bool,
  bgColor: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  variant: PropTypes.oneOf(["outlined", "filled", "standard"]),
  size: PropTypes.oneOf(["small", "medium"]),
};

export default SFTextField;
